import script from "./AddDocumentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDocumentModal.vue?vue&type=script&setup=true&lang=js"

import "./AddDocumentModal.vue?vue&type=style&index=0&id=32d7a6f8&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d7a6f8"]])

export default __exports__